import angular from 'angular';
import { forEach, size, merge } from 'lodash';
import '../app.constants';
import '../services/globals';
import '../services/line';
import '../services/area';
import '../services/user';
import '../services/errors';
import '../services/place';
import '../services/redirect-to-new-version';
import '../components/carousel';
import {
  localStorage
} from '../utils';

const module = angular.module('whyline.controllers.now-serving', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.place',
  'whyline.services.redirect-to-new-version',
  'whyline.components.carousel',
]);

const NowServingController = (SAFE_STATES, $state, $rootScope, $scope, $timeout, ErrorService, PlaceService, GlobalsService, AreaService, LineService, UserService, RedirectToNewVersionService) => {
  /*@ngInject*/

  const place = PlaceService.GetCurrent();
  const currentUser = UserService.GetCurrent();

  if (place.revertMigration) {
    RedirectToNewVersionService.Redirect('now-serving', place._id, currentUser._id, '');
  }

  // Initialization
  $scope.lines = {};
  $scope.areas = {};
  $scope.thereAreQueues = true;

  // Save the promises
  const getLines = LineService.GetMyLinesAsPromiseFromServer();
  const getAreas = AreaService.GetMyAreasAsPromiseFromServer();

  // Execute all the promises that we have
  // to get the lines and the areas for the current place
  Promise.all([getLines, getAreas])
    .then(response => {
      // Save each response in each variable
      $timeout(() => {
        $scope.lines = response[0];
        $scope.areas = response[1];
        checkThereAreQueues();
      });
    })
    .catch(ErrorService.handler);

  const checkThereAreQueues = () => {
    if(size($scope.lines) || size($scope.areas)) {
      $scope.thereAreQueues = true;
    }
  };
};

module.exports = module.controller('NowServingController', NowServingController);
